<template>
  <div class="relative mb-48">
    <div class="flex flex-col md:flex-row items-center justify-between w-full gap-4">
      <div v-for="i in 4" :key="i" class="flex flex-row mb-2 w-full border-gray-400">
        <div class="shadow border cursor-pointer bg-white rounded-md flex flex-1 items-center p-4">
          <div class="flex-1 flex-col space-y-8 pl-1 md:mr-16">
            <div class="font-medium text-gray-700 text-xl">Total Number of Students</div>
            <div class="text-red-700 text-3xl font-semibold">100</div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="py-8 overflow-x-scroll md:overflow-hidden absolute w-full" style="max-width: 98vw">
        <div class="py-4 -mx-4 sm:-mx-8 sm:px-8">
          <div class="inline-block rounded-lg shadow w-full">
            <table class="leading-normal w-full">
              <thead>
                <tr>
                  <th class="px-10 py-3 text-lg font-semibold text-gray-700 text-left uppercase bg-white border-b border-gray-200">Students</th>
                  <th class="px-10 py-3 text-lg font-semibold text-gray-700 text-center uppercase bg-white border-b border-gray-200">StudentId</th>
                  <th class="px-10 py-3 text-lg font-semibold text-gray-700 text-center uppercase bg-white border-b border-gray-200">{{ labels.CLASS }}</th>
                  <th class="px-10 py-3 text-lg font-semibold text-gray-700 text-center uppercase bg-white border-b border-gray-200">Gender</th>
                  <th class="px-10 py-3 text-lg font-semibold text-gray-700 text-center uppercase bg-white border-b border-gray-200">Grades</th>
                  <th class="px-10 py-3 text-lg font-semibold text-gray-700 text-center uppercase bg-white border-b border-gray-200">Remarks</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="student in sortedStudents" :key="student.matricNumber">
                  <td class="px-3 py-5 text-sm bg-white border-b text-center border-gray-200">
                    <div class="flex items-center">
                      <div class="flex-shrink-0">
                        <a href="#" class="relative block">
                          <img v-if="schoolLogo" :src="schoolLogo" alt="School logo" class="mx-auto object-cover rounded-full h-10 w-10" />
                          <i v-else class="pi pi-graduation-cap text-primary" style="font-size: 2rem;"></i>
                        </a>
                      </div>
                      <div class="ml-3">
                        <p class="text-lg whitespace-no-wrap">{{ student.surname }} {{ student.firstName }} {{ student.otherName}}</p>
                      </div>
                    </div>
                  </td>
                  <td class="px-5 py-5 text-lg text-center bg-white border-b border-gray-200">
                    <p class="text-gray-900 whitespace-no-wrap">{{ student.matricNumber }}</p>
                  </td>
                  <td  class="px-5 py-5 text-lg text-center bg-white border-b border-gray-200">
                    <p  class="text-gray-900 whitespace-no-wrap">
                      {{ getLastClassroom(student.studentSessions) }}
                    </p>
                  </td>
                  <td class="px-5 py-5 text-lg text-center bg-white border-b border-gray-200">
                    <p class="text-gray-900 whitespace-no-wrap">{{ formatGender(student.gender) }}</p>
                  </td>
                  <td class="px-5 py-5 text-lg text-center bg-white border-b border-gray-200">
                    <p class="text-gray-900 whitespace-no-wrap">N/A</p>
                  </td>
                  <td class="px-5 py-5 text-lg text-center bg-white border-b border-gray-200">
                    <p class="text-gray-900 whitespace-no-wrap font-semibold">N/A</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="flex flex-col items-center px-5 py-5 bg-white xs:flex-row xs:justify-between mb-60">
              <div class="flex items-center">
                <div class="flex items-center gap-10">
                  <button @click="goToPreviousPage" :disabled="currentPage === 1">Previous</button>
                  <span> {{ currentPage }} of {{ totalPages }}</span>
                  <button @click="goToNextPage" :disabled="currentPage === totalPages">Next</button>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { QUERY_STUDENTS } from '@/graphql';
import { useSchoolLabels } from '@/composables/useSchoolLabels';
import { useBranding } from '@/composables/useBranding';

const { labels } = useSchoolLabels();
const { schoolLogo } = useBranding();

const rowsPerPage = 20;
const currentPage = ref(1);
const totalPages = ref(20);
const students = ref([]);

const fetchStudents = async() => {
  const { load, result } = QUERY_STUDENTS({ page: currentPage.value, rowsPerPage });
  await load();
  students.value = result.value.students.data;
};

onMounted(() => {
  fetchStudents();
});

watch(currentPage, fetchStudents);

const sortedStudents = computed(() => students.value.slice().sort((a, b) => {
  const classA = getLastClassroom(a.studentSessions);
  const classB = getLastClassroom(b.studentSessions);
  if (classA < classB) return -1;
  if (classA > classB) return 1;
  return 0;
}));

const goToPreviousPage = () => {
  if (currentPage.value > 1) {
    currentPage.value--;
  }
};

const goToNextPage = () => {
  if (currentPage.value < totalPages.value) {
    currentPage.value++;
  }
};

const formatGender = (gender) => gender === 'M' ? 'Male' : gender === 'F' ? 'Female' : 'Other';

const getLastClassroom = (studentSessions) => {
  if (studentSessions.length > 0) {
    const lastSession = studentSessions[studentSessions.length - 1];
    return lastSession.classroom.name;
  } else {
    return 'N/A';
  }
};
</script>

<style scoped>
/* Your CSS styles */
</style>
